webpackJsonp([1],{

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(564),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(573);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

var VueTruncate = __webpack_require__(575);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(VueTruncate);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Calendar__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_calendar_Calendar__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_0__components_calendar_Calendar___default.a
  }
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarDay__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarDay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CalendarDay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarWeek__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarWeek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CalendarWeek__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CalendarMonth__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CalendarMonth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CalendarMonth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CalendarList__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CalendarList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CalendarList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*import * as tagsjson    from '../../api/events-tag.json'
import * as eventsjson  from '../../api/events-widget-content.json'*/








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "calendar",
  components: {
    CalendarDay: __WEBPACK_IMPORTED_MODULE_1__CalendarDay___default.a,
    CalendarWeek: __WEBPACK_IMPORTED_MODULE_2__CalendarWeek___default.a,
    CalendarMonth: __WEBPACK_IMPORTED_MODULE_3__CalendarMonth___default.a,
    CalendarList: __WEBPACK_IMPORTED_MODULE_4__CalendarList___default.a
  },
  data: function data() {
    return {
      tabs: [],
      tags: __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].tagsjson,
      activeParentTid: null,
      defaultTid: null,
      subTabs: [],
      depth: 0,
      view: "day",
      state: __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].state,
      statetid: __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].statetid,
      groupBy: null,

      title: null,
      subtitle: null,

      showSubTags: true,
      showTabs: true
    };
  },


  methods: {
    changeTab: function changeTab(tid, depth, parent_tid) {
      this.statetid.activeTid = tid;
      this.depth = depth;
      this.activeParentTid = parent_tid;
    },
    changeView: function changeView(viewName) {
      this.view = viewName;

      if (viewName == "day") {
        this.groupBy = "day";
      } else {
        this.groupBy = "nid";
      }

      /* this.$nextTick(function () {
          setTimeout(function(){  this.loading = false }, 3000);
       })*/
    },
    reloadEvents: function reloadEvents() {
      if (this.groupBy == "day") {
        __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].getEventsByDay();
      }
      if (this.groupBy == "nid") {
        __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].getEventsByNID();
      }
    },
    loadingStart: function loadingStart() {
      document.getElementById("widget_events_content_loader").className = "showloader";
    },
    loadingEnd: function loadingEnd() {
      setTimeout(function () {
        document.getElementById("widget_events_content_loader").className = "hideloader";
      }, 500);
    }
  },

  beforeUpdate: function beforeUpdate() {
    this.loadingStart();
  },
  updated: function updated() {
    this.$nextTick(function () {
      this.loadingEnd();
      console.log("updated");
    });
  },
  beforeMount: function beforeMount() {
    this.view = jQuery(".widget_events_content_container").attr("data-default-view");

    if (jQuery(".widget_events_content_container").attr("data-default-tag") != "") {
      this.activeParentTid = jQuery(".widget_events_content_container").attr("data-default-tag");
      this.defaultTid = jQuery(".widget_events_content_container").attr("data-default-tag");
      this.statetid.activeTid = jQuery(".widget_events_content_container").attr("data-default-tag");
      this.depth = 0;
    } else {
      this.activeParentTid = 0;
    }

    this.title = jQuery(".widget_events_content_container").attr("data-title");
    this.subtitle = jQuery(".widget_events_content_container").attr("data-subtitle");

    if (jQuery(".widget_events_content_container").attr("data-show-subtags") == 0) {
      this.showSubTags = false;
    }

    if (jQuery(".widget_events_content_container").attr("data-tab-design") == 0) {
      this.showTabs = false;
    }

    if (this.view == "day") {
      this.groupBy = "day";
    } else {
      this.groupBy = "nid";
    }
  },
  mounted: function mounted() {
    var _this = this;

    //https://www.aup.edu/sites/default/files/json/events-widget-content-new.json
    //https://www.aup.edu/api/events-widget-content-new'

    var random = Math.random();

    this.$http.get("/sites/default/files/json/events-widget-content-new.json?cache=" + random, {
      params: {},
      headers: {
        Authorization: "bearer " + localStorage.getItem("token"),
        Accept: "application/json",
        "cache-control": "no-cache"
      }
    }).then(function (response) {
      __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].eventsjson = response.body;

      if (_this.groupBy == "day") {
        __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].getEventsByDay();
      } else {
        __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].getEventsByNID();
      }
    }, function (response) {});

    // https://www.aup.edu/sites/default/files/json/event-tags.json
    // https://www.aup.edu/api/event-tags

    this.$http.get("/sites/default/files/json/event-tags.json").then(function (response) {
      _this.tags = response.body;

      _this.tabs = _this.tags.filter(function (tag) {
        return tag.parent_tid == _this.activeParentTid;
      });
    }, function (response) {});

    this.loadingEnd();
  },


  watch: {
    statetid: {
      handler: function handler(value) {
        if (this.depth == 0) {
          this.subTabs = this.tags.filter(function (tag) {
            return tag.parent_tid == value.activeTid;
          });
        }
        this.reloadEvents();
      },
      deep: true
    },
    groupBy: function groupBy(_groupBy) {
      this.reloadEvents();
    }
  },
  computed: {
    hasSubTabs: function hasSubTabs() {
      return true;
    },
    tplactiveTID: function tplactiveTID() {
      return this.statetid.activeTid;
    },
    tplEvents: function tplEvents() {
      return this.state.events;
    }
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarStoreEvents__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scrollbar_ScrollBar__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scrollbar_ScrollBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__scrollbar_ScrollBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scrollbar_ScrollBus__ = __webpack_require__(65);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'calendar-day',
	data: function data() {
		return {
			date: null,
			state: __WEBPACK_IMPORTED_MODULE_1__CalendarStoreEvents__["a" /* default */].state,
			listDays: [],
			firstDay: null,
			lastDay: null,
			wrapperId: '',
			todayPercent: 100
		};
	},

	components: {
		ScrollBar: __WEBPACK_IMPORTED_MODULE_3__scrollbar_ScrollBar___default.a
	},

	computed: {
		today: function today() {
			return __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');
		},
		listEvents: function listEvents() {

			var unordered = this.state.events;

			var ordered = {};
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(unordered).sort().forEach(function (key) {
				ordered[key] = unordered[key];
			});

			this.generateScrollId();

			this.$nextTick(function () {
				var _this = this;

				this.scrollToToday();

				setTimeout(function () {
					return _this.getTodayTop();
				}, 100);
			});

			return ordered;
		}
	},
	methods: {
		dayTitle: function dayTitle(day) {
			return __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('dddd, MMMM D YYYY');
		},
		isToday: function isToday(day) {
			if (this.today == day) {
				return true;
			}
		},
		dayID: function dayID(day) {
			if (this.today == day) {
				return "isToday";
			} else {
				var id = "dayToToday_";
				var diff = __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.today), 'day');

				return id + diff;
			}
		},
		eventsDay: function eventsDay(day) {},
		getCat: function getCat(tid) {
			return tid;
		},
		goPast: function goPast() {
			this.firstDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.firstDay).add(-1, 'month');
		},
		goFuture: function goFuture() {
			this.lastDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.lastDay).add(1, 'month');
		},
		calculateBack: function calculateBack(distPerc) {
			var full = document.getElementById(this.wrapperId).scrollHeight;
			var client = document.getElementById(this.wrapperId).offsetHeight;
			var holderHeight = full - client;

			var posOfBar = distPerc * holderHeight / 100;

			document.getElementById(this.wrapperId).scrollTop = posOfBar;
		},
		getTodayTop: function getTodayTop() {

			var target = void 0;
			var topPos = 0;
			var percent = void 0;
			var height = jQuery('.list_day-wrapper .list_day').height();

			/* scroll to today*/
			if (document.getElementById('isToday')) {
				target = document.getElementById('isToday');
				topPos = target.offsetTop;

				var _percent = (topPos + 500) * 100 / height;
				if (_percent > 100) {
					_percent = 100;
				}

				this.todayPercent = _percent;
				__WEBPACK_IMPORTED_MODULE_4__scrollbar_ScrollBus__["a" /* default */].$emit('firstLoad', _percent);
			} else {

				var i = 0;
				while (i < 500) {

					if (document.getElementById('dayToToday_' + i)) {
						target = document.getElementById('dayToToday_' + i);
						break;
					}

					i++;
				}

				if (target) {
					topPos = target.offsetTop;
					var _percent2 = (topPos + 500) * 100 / height;
					if (_percent2 > 100) {
						_percent2 = 100;
					}
					this.todayPercent = _percent2;

					__WEBPACK_IMPORTED_MODULE_4__scrollbar_ScrollBus__["a" /* default */].$emit('firstLoad', _percent2);
				} else {
					var _percent3 = 100;
					this.todayPercent = _percent3;
					__WEBPACK_IMPORTED_MODULE_4__scrollbar_ScrollBus__["a" /* default */].$emit('firstLoad', _percent3);
				}
			}
		},
		scrollToToday: function scrollToToday() {

			var target = void 0;
			var topPos = 0;

			var height = jQuery('.list_day-wrapper .list_day').height();
			/* scroll to today*/
			if (document.getElementById('isToday')) {
				target = document.getElementById('isToday');
				topPos = target.offsetTop;

				var percent = (topPos + 500) * 100 / height;

				if (percent > 100) {
					percent = 100;
				}

				__WEBPACK_IMPORTED_MODULE_4__scrollbar_ScrollBus__["a" /* default */].$emit('change', percent);
			} else {

				var i = 0;
				while (i < 500) {

					if (document.getElementById('dayToToday_' + i)) {
						target = document.getElementById('dayToToday_' + i);
						break;
					}

					i++;
				}

				if (target) {
					topPos = target.offsetTop;
					var _percent4 = (topPos + 500) * 100 / height;

					__WEBPACK_IMPORTED_MODULE_4__scrollbar_ScrollBus__["a" /* default */].$emit('change', _percent4);
				} else {
					__WEBPACK_IMPORTED_MODULE_4__scrollbar_ScrollBus__["a" /* default */].$emit('change', 100);
				}
			}
		},
		generateScrollId: function generateScrollId() {
			var _this2 = this;

			this.wrapperId = Math.random().toString(36).substring(7);
			__WEBPACK_IMPORTED_MODULE_4__scrollbar_ScrollBus__["a" /* default */].$on('change', function (msg) {
				_this2.calculateBack(msg);
			});
		},
		getColorClass: function getColorClass(tid, parentTid) {
			return __WEBPACK_IMPORTED_MODULE_1__CalendarStoreEvents__["a" /* default */].getColorClass(tid, parentTid);
		},
		classEventList: function classEventList(events) {
			return 'contain_' + events.length + '_items';
		},
		handleScroll: function handleScroll(e) {

			var height = e.target.scrollHeight;
			var client = e.target.offsetHeight;
			var maxScroll = height - client;
			var topPos = e.target.scrollTop;

			var percent = topPos * 100 / maxScroll;

			__WEBPACK_IMPORTED_MODULE_4__scrollbar_ScrollBus__["a" /* default */].$emit('scrollUpdate', percent);
		}
	},

	mounted: function mounted() {
		var _this3 = this;

		this.date = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
		this.firstDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.date).startOf('month');
		this.lastDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.date).endOf('month');

		__WEBPACK_IMPORTED_MODULE_4__scrollbar_ScrollBus__["a" /* default */].$on('gotToToday', function (msg) {

			var full = document.getElementById(_this3.wrapperId).scrollHeight;
			var client = document.getElementById(_this3.wrapperId).offsetHeight;
			var holderHeight = full - client;

			var posToday = _this3.todayPercent * holderHeight / 100;
			document.getElementById(_this3.wrapperId).scrollTop = posToday;
		});
	},
	updated: function updated() {

		document.getElementById(this.wrapperId).addEventListener('scroll', this.handleScroll);
	}
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'calendar-list',
	components: {
		Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a
	},
	data: function data() {
		return {
			date: null,
			filters: { searchText: '', searchYear: '', searchMonth: '', searchDateStart: '', searchDateEnd: '' },
			state: __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].state,
			listEvents: []

		};
	},
	mounted: function mounted() {
		this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()();

		this.listEvents = this.state.events;

		this.filterEvents();
	},

	computed: {
		getLastYear: function getLastYear() {
			var lastEvent = this.state.events[0];
			if (lastEvent) {
				return __WEBPACK_IMPORTED_MODULE_1_moment___default()(lastEvent['dateEnd']).format('YYYY');
			}
		},
		getFirstYear: function getFirstYear() {

			var sortedEvents = _.sortBy(this.state.events, function (o) {
				return new __WEBPACK_IMPORTED_MODULE_1_moment___default.a(o.dateStart);
			});

			var firstEvent = sortedEvents[0];

			if (firstEvent) {
				return __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstEvent['dateStart']).format('YYYY');
			}
		},
		getYearRange: function getYearRange() {
			var yearRange = [];
			var start = this.getFirstYear;
			var end = this.getLastYear;

			while (start <= end) {
				yearRange.push(start++);
			}

			return yearRange;
		}
	},
	methods: {
		clearByMonth: function clearByMonth() {
			this.filters.searchYear = '';
			this.filters.searchMonth = '';
		},
		clearByDate: function clearByDate() {
			this.filters.searchDateStart = '';
			this.filters.searchDateEnd = '';
		},
		displayMonth: function displayMonth(n) {
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(n).format("MMMM");
		},
		classList: function classList(date) {

			var eventDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date);
			var todayDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()();

			if (eventDate == todayDate) {
				return 'isToday';
			} else {
				var diff = eventDate.diff(todayDate, 'days') + 1;

				return 'daydiff-' + diff;
			}
		},
		displayDate: function displayDate(date) {
			var hour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (hour == false) {
				if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD') == __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')) {
					return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format(', DD MMMM');
				} else {
					return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('dddd, DD MMMM YYYY');
				}
			} else {
				if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD') == __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')) {
					return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format(', DD MMMM') + ' ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('HH') + 'h' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('mm');
				} else {
					return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('dddd, DD MMMM YYYY') + ' ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('HH') + 'h' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('mm');
					//return moment(date) +'test'
				}
			}
		},
		isToday: function isToday(date) {
			if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD') == __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')) {
				return true;
			}
		},
		filterEvents: function filterEvents() {

			var events = this.state.events;

			var searchText = this.filters.searchText;
			var searchYear = this.filters.searchYear;
			var searchMonth = this.filters.searchMonth;
			var searchDateStart = this.filters.searchDateStart;
			var searchDateEnd = this.filters.searchDateEnd;

			if (searchText != '') {
				events = events.filter(function (event) {
					return event.searchtext.toLowerCase().includes(searchText.toLowerCase());
				});
			}

			if (searchDateStart == '' && searchDateEnd == '') {

				if (searchYear != '') {
					var month = __WEBPACK_IMPORTED_MODULE_1_moment___default()().month(searchMonth).format('MM');
					var searchMonthNew = searchYear + '-' + month;

					events = events.filter(function (event) {
						if (searchMonth == '') {
							return __WEBPACK_IMPORTED_MODULE_1_moment___default()(event.dateStart).format('YYYY') == searchYear;
						} else {

							return __WEBPACK_IMPORTED_MODULE_1_moment___default()(event.dateStart).format('YYYY-MM') == searchMonthNew;
						}
					});
				} else {

					events = events.filter(function (event) {

						return __WEBPACK_IMPORTED_MODULE_1_moment___default()(event.dateStart).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()()) == true;
					});
				}
			} else {

				if (searchDateStart != '' && searchDateEnd == '') {
					this.filters.searchYear = '';
					events = events.filter(function (event) {
						return __WEBPACK_IMPORTED_MODULE_1_moment___default()(event.dateStart).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(searchDateStart), 'day');
					});
				}
				if (searchDateStart == '' && searchDateEnd != '') {
					this.filters.searchYear = '';
					events = events.filter(function (event) {
						return __WEBPACK_IMPORTED_MODULE_1_moment___default()(event.dateStart).isSameOrBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(searchDateEnd), 'day');
					});
				}
				if (searchDateStart != '' && searchDateEnd != '') {
					this.filters.searchYear = '';
					events = events.filter(function (event) {
						return __WEBPACK_IMPORTED_MODULE_1_moment___default()(event.dateStart).isBetween(__WEBPACK_IMPORTED_MODULE_1_moment___default()(searchDateStart), __WEBPACK_IMPORTED_MODULE_1_moment___default()(searchDateEnd), 'days', '[]');
					});
				}
			}

			this.listEvents = _.sortBy(events, function (o) {
				return new __WEBPACK_IMPORTED_MODULE_1_moment___default.a(o.dateStart);
			});
		},
		resetFromToDateSearch: function resetFromToDateSearch() {
			this.filters.searchDateStart = '';
			this.filters.searchDateEnd = '';
		},
		resetYearSearch: function resetYearSearch() {}
	},

	watch: {
		state: {
			handler: function handler(value) {

				this.listEvents = this.state.events;
				this.filters = { searchText: '', searchYear: '', searchMonth: '', searchDateStart: '', searchDateEnd: '' }, this.filterEvents();
			},
			deep: true
		},
		filters: {
			handler: function handler(after, before) {

				this.filterEvents();
			},
			deep: true
		}
	}

});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DayCell__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DayCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DayCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OneEvent__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OneEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OneEvent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "calendar-month",
  components: { DayCell: __WEBPACK_IMPORTED_MODULE_2__DayCell___default.a, OneEvent: __WEBPACK_IMPORTED_MODULE_3__OneEvent___default.a },
  data: function data() {
    return {
      date: null,
      state: __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].state
    };
  },
  mounted: function mounted() {
    this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
  },

  computed: {
    displayMonth: function displayMonth() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format("MMMM");
    },
    displayYear: function displayYear() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format("YYYY");
    },
    displayWeek: function displayWeek() {
      var weekNum = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format("w");
      var currentWeek = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("w");

      if (weekNum == currentWeek) {
        return "This week";
      } else {
        return "Week #" + weekNum;
      }
    },
    allMonth: function allMonth() {
      var startOfMonth = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).startOf("month");
      var startOfMonthIndex = startOfMonth.weekday();
      var letStartOfMonthCalendar = startOfMonth.add(-startOfMonthIndex, "day");

      var endOfMonth = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).endOf("month");
      var endOfMonthIndex = endOfMonth.weekday();
      var endOfMonthCalendar = 6 - endOfMonthIndex;
      endOfMonthIndex = endOfMonth.add(endOfMonthCalendar, "day");

      var days = [];
      var day = letStartOfMonthCalendar;

      while (day <= endOfMonth) {
        days.push(day.toDate());
        day = day.clone().add(1, "d");
      }

      var rows = this.chunkArray(days, 7);

      return rows;
    }
  },
  methods: {
    prevMonth: function prevMonth() {
      this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).add(-1, "month");
    },
    nextMonth: function nextMonth() {
      this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).add(1, "month");
    },
    chunkArray: function chunkArray(arr, chunkSize) {
      var groups = [],
          i;
      for (i = 0; i < arr.length; i += chunkSize) {
        groups.push(arr.slice(i, i + chunkSize));
      }
      return groups;
    },
    multidaysEvents: function multidaysEvents(days) {
      var dayStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(days[0]);
      var dayEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default()(days[6]);

      console.log("couocu", days);

      return __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].filterByDayMultiple(this.state.events, dayStart, dayEnd);
    },
    calculateWidth: function calculateWidth(days, start, end) {
      var dayStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(days[0]);
      var dayEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default()(days[6]);

      var dateStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start);
      var dateEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default()(end);
      var width = void 0;
      var paddingStart = void 0;

      var dayToStart = void 0;
      var dayToEnd = void 0;

      if (dateStart.isSameOrBefore(dayStart)) {
        dayToStart = 0;
        paddingStart = 0;
      } else {
        dayToStart = dateStart.diff(dayStart, "days");
        paddingStart = dayToStart / 7 * 100;
      }

      if (dateEnd.isAfter(dayEnd)) {
        dayToEnd = 0;
      } else {
        dayToEnd = dayEnd.diff(dateEnd, "days");
      }

      var eventDayLength = 7 - dayToStart - dayToEnd;

      width = eventDayLength / 7 * 100;

      return "margin-left:" + paddingStart + "%; width: " + width + "%;";
    }
  }
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scrollbar_ScrollBarHorizontal__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scrollbar_ScrollBarHorizontal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scrollbar_ScrollBarHorizontal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scrollbar_ScrollBus__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OneEvent__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OneEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OneEvent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'calendar-week',
	data: function data() {
		return {
			date: null,
			state: __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].state,
			events: __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].state.events,
			wrapperId: ''
		};
	},

	components: {
		ScrollBarHorizontal: __WEBPACK_IMPORTED_MODULE_2__scrollbar_ScrollBarHorizontal___default.a, OneEvent: __WEBPACK_IMPORTED_MODULE_4__OneEvent___default.a
	},
	created: function created() {
		var _this = this;

		this.wrapperId = Math.random().toString(36).substring(7);
		__WEBPACK_IMPORTED_MODULE_3__scrollbar_ScrollBus__["a" /* default */].$on('changeHorizontal', function (msg) {
			_this.calculateBack(msg);
		});
	},
	mounted: function mounted() {
		this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
	},

	computed: {
		displayMonth: function displayMonth() {
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format('MMMM');
		},
		displayYear: function displayYear() {
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format('YYYY');
		},
		displayWeek: function displayWeek() {

			var weekNum = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format('w');
			var currentWeek = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('w');

			if (weekNum == currentWeek) {
				return 'This week';
			} else {
				return 'Week #' + weekNum;
			}
		},
		allWeek: function allWeek() {
			var startOfWeek = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).startOf('isoWeek');
			var endOfWeek = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).endOf('isoWeek');
			var days = [];
			var day = startOfWeek;

			while (day <= endOfWeek) {
				days.push(day.toDate());
				day = day.clone().add(1, 'd');
			}
			return days;
		},
		multidaysEvents: function multidaysEvents() {
			var startOfWeek = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).startOf('isoWeek');
			var endOfWeek = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).endOf('isoWeek');

			return __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].filterByDayMultiple(this.state.events, startOfWeek, endOfWeek);
		},
		holderWidth: function holderWidth() {

			if (document.getElementById(this.wrapperId)) {
				var full = document.getElementById(this.wrapperId).scrollWidth;
				var client = document.getElementById(this.wrapperId).offsetWidth;
				return full - client;
			}
		}
	},
	methods: {
		prevWeek: function prevWeek() {
			this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).add(-7, 'days');
		},
		nextWeek: function nextWeek() {
			this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).add(7, 'days');
		},
		displayDayName: function displayDayName(date) {
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('dddd');
		},
		displayDayNum: function displayDayNum(date) {
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('DD');
		},
		displayDayEvents: function displayDayEvents(date) {
			return __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].filterByDaySingle(this.state.events, date);
		},
		isToday: function isToday(date) {

			if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD') == __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')) {
				return true;
			}
		},
		calculateWidth: function calculateWidth(start, end, days) {

			var dateStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start);
			var dateEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default()(end);
			var startWeek = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).startOf('isoWeek');
			var width = void 0;
			var paddingStart = void 0;

			var totalDays = days;
			var daysBefore = 0;

			if (totalDays >= 7) {
				width = 100;
				paddingStart = 0;
			} else {
				width = totalDays / 7 * 100;

				daysBefore = startWeek.diff(dateStart, 'days');

				if (daysBefore < 0) {
					daysBefore = Math.abs(daysBefore);
					paddingStart = daysBefore / 7 * 100;
				} else {
					paddingStart = 0;
				}
			}

			return 'margin-left:' + paddingStart + '%; width: ' + width + '%;';
		},
		calculateBack: function calculateBack(distPerc) {
			var posOfBar = distPerc * this.holderWidth / 100;
			document.getElementById(this.wrapperId).scrollLeft = posOfBar;
		},
		handleScroll: function handleScroll(e) {

			var width = e.target.scrollWidth;
			var scrollLeftMax = width - document.getElementById(this.wrapperId).offsetWidth;

			var topLeft = e.target.scrollLeft;

			var percent = topLeft * 100 / scrollLeftMax;

			__WEBPACK_IMPORTED_MODULE_3__scrollbar_ScrollBus__["a" /* default */].$emit('scrollUpdateHorizontal', percent);
		}
	},
	updated: function updated() {

		document.getElementById(this.wrapperId).addEventListener('scroll', this.handleScroll);
	}
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarStoreEvents__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OneEvent__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OneEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OneEvent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'day-cell',
	props: ['day', 'row'],
	data: function data() {
		return {
			date: null,
			state: __WEBPACK_IMPORTED_MODULE_1__CalendarStoreEvents__["a" /* default */].state,
			seeMoreToggle: false,
			selectclass: false
		};
	},

	directives: {
		onClickaway: __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]
	},

	components: { OneEvent: __WEBPACK_IMPORTED_MODULE_3__OneEvent___default.a },
	methods: {
		toggleSeeMore: function toggleSeeMore() {
			this.seeMoreToggle = !this.seeMoreToggle;
		},
		isToday: function isToday(date) {

			if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('YYYY-MM-DD') == __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')) {
				return true;
			}
		},
		displayDay: function displayDay(date, row) {
			var dayNum = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD');

			if (row == 0) {
				return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('ddd');
			}
		},
		displayDayNum: function displayDayNum(date, row) {
			var dayNum = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD');

			if (row == 0 && dayNum <= 7) {
				return dayNum;
			}

			if (row > 0 && row < 4) {
				return dayNum;
			}

			if (row == 4 && dayNum > 20) {
				return dayNum;
			}
		},
		displayDayEvents: function displayDayEvents(date) {

			return __WEBPACK_IMPORTED_MODULE_1__CalendarStoreEvents__["a" /* default */].filterByDaySingle(this.state.events, date);
		},


		childenClicked: function childenClicked(id) {

			this.selectclass = id;
		},
		away: function away() {
			this.selectclass = false;
		}
	}

});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'event-hover',
	props: ['event'],
	data: function data() {
		return {};
	},

	computed: {
		eventDate: function eventDate() {

			var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.event.dateStart).format('MMM Do');

			if (this.event.dateEnd != '' && this.event.dateEnd != this.event.dateStart) {

				var end = ' to ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.event.dateEnd).format('MMM Do');
				return start + end;
			} else {
				return start;
			}
		}
	},
	methods: {
		getColorClass: function getColorClass(tid, parentTid) {
			return __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].getColorClass(tid, parentTid);
		}
	}

});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventHover__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventHover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EventHover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'one-event',
	props: ['event', 'showTime', 'longTitle'],
	components: { EventHover: __WEBPACK_IMPORTED_MODULE_1__EventHover___default.a },

	data: function data() {
		return {

			isClicked: false
		};
	},

	directives: {
		onClickaway: __WEBPACK_IMPORTED_MODULE_2_vue_clickaway__["directive"]
	},
	mounted: function mounted() {
		// prevent click outside event with popupItem.
		this.popupItem = this.$el;
	},

	methods: {
		toggleClick: function toggleClick() {
			this.$emit('eventchild', true);
			this.isClicked = true;
		},
		away: function away() {
			this.isClicked = false;
		},
		getColorClass: function getColorClass(tid, parentTid) {
			return __WEBPACK_IMPORTED_MODULE_0__CalendarStoreEvents__["a" /* default */].getColorClass(tid, parentTid);
		}
	}

});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollBus__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'scrollbar',
    data: function data() {
        return {
            barId: '',
            sliderId: ''

        };
    },


    mounted: function mounted() {
        var _this = this;

        document.onmouseup = this.clear;

        __WEBPACK_IMPORTED_MODULE_0__ScrollBus__["a" /* default */].$on('change', function (msg) {

            var startTop = msg * _this.barHeight / 100;

            if (document.getElementById(_this.sliderId)) {
                document.getElementById(_this.sliderId).style.top = startTop + 'px';
            }
        });

        __WEBPACK_IMPORTED_MODULE_0__ScrollBus__["a" /* default */].$on('scrollUpdate', function (msg) {

            var startTop = msg * _this.barHeight / 100;
            if (document.getElementById(_this.sliderId)) {
                document.getElementById(_this.sliderId).style.top = startTop + 'px';
            }
        });

        __WEBPACK_IMPORTED_MODULE_0__ScrollBus__["a" /* default */].$on('firstLoad', function (msg) {
            var startTop = msg * _this.barHeight / 100;
            if (document.getElementById(_this.sliderId)) {
                document.getElementById('go_to_today').style.top = startTop + 'px';
            }
        });
    },
    methods: {
        goToToday: function goToToday() {

            __WEBPACK_IMPORTED_MODULE_0__ScrollBus__["a" /* default */].$emit('gotToToday', "coucou");
        },
        bindMouseDown: function bindMouseDown() {

            document.onmousemove = this.calculatePosition;
        },
        clear: function clear() {

            document.onmousemove = null;
        },
        calculatePosition: function calculatePosition(event) {
            var mousePos = event.clientY;
            var barOffset = document.getElementById(this.barId).getBoundingClientRect().top;

            // Making the lowest point on the bar zero
            var absolutePosOnBar = mousePos - barOffset;

            // Half of the slider is insignificant for calculating
            // the length travelled by it. Hence - (this.sliderWidth / 2)
            var posOnBar = absolutePosOnBar - this.slideHeight / 2;

            // The length of the bar actually used for calculation purposes
            var clickableAreaLength = this.barHeight - this.slideHeight;

            var slider = document.getElementById(this.sliderId);
            // The distance travelled as percentage
            // to be sent to the gallery component
            var percToSend = posOnBar * 100 / clickableAreaLength;

            var displayPerc = posOnBar;

            // This is done to prevent the slider move behind
            // its "point 0"
            if (displayPerc < 0) {
                displayPerc = 0;
            }

            if (displayPerc > clickableAreaLength) {
                displayPerc = clickableAreaLength;
            }

            __WEBPACK_IMPORTED_MODULE_0__ScrollBus__["a" /* default */].$emit('change', percToSend);

            if (slider) {
                slider.style.top = displayPerc + 'px';
            }
        },
        elementPos: function elementPos(el) {
            var rect = el.getBoundingClientRect(),

            // scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return rect.top + scrollTop;
        }
    },
    computed: {
        barHeight: function barHeight() {
            var bar = document.getElementById(this.barId);
            if (bar) return bar.offsetHeight;
        },
        slideHeight: function slideHeight() {
            var slider = document.getElementById(this.sliderId);
            return slider.offsetHeight;
        }
    },
    created: function created() {
        this.barId = Math.random().toString(36).substring(7);
        this.sliderId = Math.random().toString(36).substring(7);
    }
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollBus__ = __webpack_require__(65);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            barId: '',
            sliderId: ''
        };
    },


    mounted: function mounted() {
        var _this = this;

        document.onmouseup = this.clear;

        __WEBPACK_IMPORTED_MODULE_0__ScrollBus__["a" /* default */].$on('scrollUpdateHorizontal', function (msg) {

            var startLeft = msg * _this.barWidth / 100;
            if (document.getElementById(_this.sliderId)) {
                document.getElementById(_this.sliderId).style.left = startLeft + 'px';
            }
        });
    },
    methods: {
        bindMouseDown: function bindMouseDown() {
            console.log("click");
            document.onmousemove = this.calculatePosition;
        },
        clear: function clear() {
            console.log("clear");
            document.onmousemove = null;
        },
        calculatePosition: function calculatePosition(event) {
            var mousePos = event.clientX;
            var sliderOffset = this.calculateSliderOffset();

            // Making the lowest point on the bar zero
            var absolutePosOnBar = mousePos - this.barOffset;

            // Half of the slider is insignificant for calculating
            // the length travelled by it. Hence - (this.sliderWidth / 2)
            var posOnBar = absolutePosOnBar - this.sliderWidth / 2;

            // The length of the bar actually used for calculation purposes
            var clickableAreaLength = this.barWidth - this.sliderWidth;

            // The maximum distance on the bar
            if (posOnBar > clickableAreaLength) {
                posOnBar = clickableAreaLength;
            }

            // If the mouse curser is left or right of the scrollbar
            // (i.e. not on the scrollbar)
            // stop doing scrolling
            if (absolutePosOnBar < 0 || posOnBar > this.barWidth + this.barOffset) {
                this.clear();
            }

            var slider = document.getElementById(this.sliderId);

            // The distance travelled as percentage
            // to be sent to the gallery component
            var percToSend = posOnBar * 100 / clickableAreaLength;

            var displayPerc = posOnBar;

            // This is done to prevent the slider move behind
            // its "point 0"
            if (0 > displayPerc) {
                displayPerc = 0;
            }

            __WEBPACK_IMPORTED_MODULE_0__ScrollBus__["a" /* default */].$emit('changeHorizontal', percToSend);
            slider.style.left = displayPerc + 'px';
        },
        elementPos: function elementPos(el) {
            var rect = el.getBoundingClientRect();
            var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            return rect.left + scrollLeft;
        },
        calculateSliderOffset: function calculateSliderOffset() {
            var slider = document.getElementById(this.sliderId);
            //var rect = slider.getBoundingClientRect();
            //return rect.left;
            return this.elementPos(slider);
        }
    },
    computed: {
        barWidth: function barWidth() {
            var bar = document.getElementById(this.barId);
            return bar.offsetWidth;
        },
        sliderWidth: function sliderWidth() {
            var slider = document.getElementById(this.sliderId);
            return slider.offsetWidth;
        },
        barOffset: function barOffset() {
            var bar = document.getElementById(this.barId);
            return this.elementPos(bar);
        }
    },
    created: function created() {
        this.barId = Math.random().toString(36).substring(7);
        this.sliderId = Math.random().toString(36).substring(7);
    }
});

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);




/*import * as this.eventsjson  from 'https://www.aup.edu/sites/default/files/json/events-widget-content-new.json'
*/



var CalendarFilters = function () {
	function CalendarFilters() {
		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CalendarFilters);

		this.eventsjson = [], this.tagsjson = [], this.state = {
			events: [],
			loading: true

		}, this.statetid = {
			activeTid: null
		};
	}

	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CalendarFilters, [{
		key: 'removeDuplicatesBy',
		value: function removeDuplicatesBy(keyFn, array) {
			var mySet = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
			this.state.events = array.filter(function (x) {
				var key = keyFn(x),
				    isNew = !mySet.has(key);
				if (isNew) mySet.add(key);
				return isNew;
			});
		}
	}, {
		key: 'getEventsByNID',
		value: function getEventsByNID() {
			var _this = this;

			var results;
			if (this.statetid.activeTid != null) {
				results = this.eventsjson.filter(function (node) {
					var allTids = node.parents_id.replace(/\s/g, '').split(',');
					return allTids.indexOf(_this.statetid.activeTid) !== -1;
				});
			} else {
				results = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniqBy(this.eventsjson, function (p) {
					return p.nid;
				});
			}
			this.state.events = results;
		}
	}, {
		key: 'getColorClass',
		value: function getColorClass(tids, parentTids) {
			var redTid = '77';
			var greyTid = '78';

			var allTids = tids + ', ' + parentTids;
			allTids = allTids.replace(/\s/g, '').split(',');

			if (allTids.indexOf(redTid) !== -1) {
				return "colorRed";
			} else if (allTids.indexOf(greyTid) !== -1) {
				return "colorGrey";
			} else {
				return "colorBlue";
			}
		}
	}, {
		key: 'getEventsByDay',
		value: function getEventsByDay() {
			var _this2 = this;

			var results;

			var minDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'y').format('YYYY-MM-DD');

			if (this.statetid.activeTid != null) {
				results = this.eventsjson.filter(function (node) {
					var allTids = node.parents_id.replace(/\s/g, '').split(',');
					return node.dateEnd > minDate && allTids.indexOf(_this2.statetid.activeTid) !== -1;
				});
			} else {
				results = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniqBy(this.eventsjson, function (p) {
					return p.nid;
				});
			}

			results = results.filter(function (node) {
				return node.dateEnd > minDate;
			});

			var array = {};

			for (var i in results) {

				var result = results[i];

				if (result.dateStart != result.dateEnd) {
					var startDate = new Date(result.dateStart);
					var endDate = new Date(result.dateEnd);

					while (startDate <= endDate) {

						var newDate = startDate.setDate(startDate.getDate() + 1);

						startDate = new Date(newDate);

						var pushDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startDate).subtract(1, 'day').format('YYYY-MM-DD');

						if (typeof array[pushDate] == 'undefined') {
							array[pushDate] = [];
						}

						array[pushDate].push(result);
					}
				} else {

					if (typeof array[result.dateStart] == 'undefined') {
						array[result.dateStart] = [];
					}

					array[result.dateStart].push(result);
				}
			}

			this.state.events = array;
		}
	}, {
		key: 'filterByDaySingle',
		value: function filterByDaySingle(events, day) {

			var checkDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(day).format("YYYY-MM-DD");
			var niqueNID = [];

			return events.filter(function (event) {

				if (event.dateStart == event.dateEnd && event.dateStart == checkDate) {

					if (!niqueNID.includes(event.nid)) {
						niqueNID.push(event.nid);
						return event;
					}
				}
			});
		}
	}, {
		key: 'filterByDayMultiple',
		value: function filterByDayMultiple(events, start, end) {

			var filteredEvents = [];
			var niqueNID = [];

			for (var i = 0, len = events.length; i < len; i++) {

				var event = events[i];

				var startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(event.dateStart);
				var endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(event.dateEnd);

				var yearStart = __WEBPACK_IMPORTED_MODULE_3_moment___default()(event.dateStart).format('Y');
				var yearEnd = __WEBPACK_IMPORTED_MODULE_3_moment___default()(event.dateEnd).format('Y');

				if (event.nid == 4958) {
					if (!startDate.isSame(endDate)) {
						console.log('1');
					}

					if (start.isBetween(startDate, endDate, 'day', '[]')) {
						console.log('2');
					}

					if (end.isBetween(startDate, endDate, 'day', '[]')) {
						console.log('3');
					}

					if (startDate.isBetween(start, end, 'day', '[]')) {
						console.log('4');
					}

					if (endDate.isBetween(start, end, 'day', '[]')) {
						console.log('5');
					}
				}

				if (!startDate.isSame(endDate) && (start.isBetween(startDate, endDate, 'day', '[]') || end.isBetween(startDate, endDate, 'day', '[]') || startDate.isBetween(start, end, 'day', '[]') || endDate.isBetween(start, end, 'day', '[]'))) {

					var dayToStart = void 0;
					var dayToEnd = void 0;

					if (startDate.isSameOrBefore(start)) {
						dayToStart = 0;
					} else {
						dayToStart = startDate.diff(start, 'days');
					}

					if (endDate.isAfter(end)) {
						dayToEnd = 0;
					} else {
						dayToEnd = end.diff(endDate, 'days');
					}

					var numberDay = 7 - dayToStart - dayToEnd;

					event['daysNum'] = numberDay;

					if (!niqueNID.includes(event.nid)) {
						niqueNID.push(event.nid);
						filteredEvents.push(event);
					}
				}
			}

			return filteredEvents.sort(function (a, b) {
				return a.daysNum - b.daysNum;
			});
		}
	}, {
		key: 'howManyMultiEventPerDay',
		value: function howManyMultiEventPerDay(events, day) {
			var incr = 0;

			for (var i = 0, len = events.length; i < len; i++) {

				var event = events[i];
				var startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(event.dateStart);
				var endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(event.dateEnd);

				if (!startDate.isSame(endDate) && day.isBetween(startDate, endDate, 'day', '[)')) {

					incr++;
				}
			}

			return incr;
		}
	}]);

	return CalendarFilters;
}();

/* harmony default export */ __webpack_exports__["a"] = (new CalendarFilters());

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 168,
	"./af.js": 168,
	"./ar": 175,
	"./ar-dz": 169,
	"./ar-dz.js": 169,
	"./ar-kw": 170,
	"./ar-kw.js": 170,
	"./ar-ly": 171,
	"./ar-ly.js": 171,
	"./ar-ma": 172,
	"./ar-ma.js": 172,
	"./ar-sa": 173,
	"./ar-sa.js": 173,
	"./ar-tn": 174,
	"./ar-tn.js": 174,
	"./ar.js": 175,
	"./az": 176,
	"./az.js": 176,
	"./be": 177,
	"./be.js": 177,
	"./bg": 178,
	"./bg.js": 178,
	"./bn": 179,
	"./bn.js": 179,
	"./bo": 180,
	"./bo.js": 180,
	"./br": 181,
	"./br.js": 181,
	"./bs": 182,
	"./bs.js": 182,
	"./ca": 183,
	"./ca.js": 183,
	"./cs": 184,
	"./cs.js": 184,
	"./cv": 185,
	"./cv.js": 185,
	"./cy": 186,
	"./cy.js": 186,
	"./da": 187,
	"./da.js": 187,
	"./de": 190,
	"./de-at": 188,
	"./de-at.js": 188,
	"./de-ch": 189,
	"./de-ch.js": 189,
	"./de.js": 190,
	"./dv": 191,
	"./dv.js": 191,
	"./el": 192,
	"./el.js": 192,
	"./en-au": 193,
	"./en-au.js": 193,
	"./en-ca": 194,
	"./en-ca.js": 194,
	"./en-gb": 195,
	"./en-gb.js": 195,
	"./en-ie": 196,
	"./en-ie.js": 196,
	"./en-nz": 197,
	"./en-nz.js": 197,
	"./eo": 198,
	"./eo.js": 198,
	"./es": 200,
	"./es-do": 199,
	"./es-do.js": 199,
	"./es.js": 200,
	"./et": 201,
	"./et.js": 201,
	"./eu": 202,
	"./eu.js": 202,
	"./fa": 203,
	"./fa.js": 203,
	"./fi": 204,
	"./fi.js": 204,
	"./fo": 205,
	"./fo.js": 205,
	"./fr": 208,
	"./fr-ca": 206,
	"./fr-ca.js": 206,
	"./fr-ch": 207,
	"./fr-ch.js": 207,
	"./fr.js": 208,
	"./fy": 209,
	"./fy.js": 209,
	"./gd": 210,
	"./gd.js": 210,
	"./gl": 211,
	"./gl.js": 211,
	"./gom-latn": 212,
	"./gom-latn.js": 212,
	"./he": 213,
	"./he.js": 213,
	"./hi": 214,
	"./hi.js": 214,
	"./hr": 215,
	"./hr.js": 215,
	"./hu": 216,
	"./hu.js": 216,
	"./hy-am": 217,
	"./hy-am.js": 217,
	"./id": 218,
	"./id.js": 218,
	"./is": 219,
	"./is.js": 219,
	"./it": 220,
	"./it.js": 220,
	"./ja": 221,
	"./ja.js": 221,
	"./jv": 222,
	"./jv.js": 222,
	"./ka": 223,
	"./ka.js": 223,
	"./kk": 224,
	"./kk.js": 224,
	"./km": 225,
	"./km.js": 225,
	"./kn": 226,
	"./kn.js": 226,
	"./ko": 227,
	"./ko.js": 227,
	"./ky": 228,
	"./ky.js": 228,
	"./lb": 229,
	"./lb.js": 229,
	"./lo": 230,
	"./lo.js": 230,
	"./lt": 231,
	"./lt.js": 231,
	"./lv": 232,
	"./lv.js": 232,
	"./me": 233,
	"./me.js": 233,
	"./mi": 234,
	"./mi.js": 234,
	"./mk": 235,
	"./mk.js": 235,
	"./ml": 236,
	"./ml.js": 236,
	"./mr": 237,
	"./mr.js": 237,
	"./ms": 239,
	"./ms-my": 238,
	"./ms-my.js": 238,
	"./ms.js": 239,
	"./my": 240,
	"./my.js": 240,
	"./nb": 241,
	"./nb.js": 241,
	"./ne": 242,
	"./ne.js": 242,
	"./nl": 244,
	"./nl-be": 243,
	"./nl-be.js": 243,
	"./nl.js": 244,
	"./nn": 245,
	"./nn.js": 245,
	"./pa-in": 246,
	"./pa-in.js": 246,
	"./pl": 247,
	"./pl.js": 247,
	"./pt": 249,
	"./pt-br": 248,
	"./pt-br.js": 248,
	"./pt.js": 249,
	"./ro": 250,
	"./ro.js": 250,
	"./ru": 251,
	"./ru.js": 251,
	"./sd": 252,
	"./sd.js": 252,
	"./se": 253,
	"./se.js": 253,
	"./si": 254,
	"./si.js": 254,
	"./sk": 255,
	"./sk.js": 255,
	"./sl": 256,
	"./sl.js": 256,
	"./sq": 257,
	"./sq.js": 257,
	"./sr": 259,
	"./sr-cyrl": 258,
	"./sr-cyrl.js": 258,
	"./sr.js": 259,
	"./ss": 260,
	"./ss.js": 260,
	"./sv": 261,
	"./sv.js": 261,
	"./sw": 262,
	"./sw.js": 262,
	"./ta": 263,
	"./ta.js": 263,
	"./te": 264,
	"./te.js": 264,
	"./tet": 265,
	"./tet.js": 265,
	"./th": 266,
	"./th.js": 266,
	"./tl-ph": 267,
	"./tl-ph.js": 267,
	"./tlh": 268,
	"./tlh.js": 268,
	"./tr": 269,
	"./tr.js": 269,
	"./tzl": 270,
	"./tzl.js": 270,
	"./tzm": 272,
	"./tzm-latn": 271,
	"./tzm-latn.js": 271,
	"./tzm.js": 272,
	"./uk": 273,
	"./uk.js": 273,
	"./ur": 274,
	"./ur.js": 274,
	"./uz": 276,
	"./uz-latn": 275,
	"./uz-latn.js": 275,
	"./uz.js": 276,
	"./vi": 277,
	"./vi.js": 277,
	"./x-pseudo": 278,
	"./x-pseudo.js": 278,
	"./yo": 279,
	"./yo.js": 279,
	"./zh-cn": 280,
	"./zh-cn.js": 280,
	"./zh-hk": 281,
	"./zh-hk.js": 281,
	"./zh-tw": 282,
	"./zh-tw.js": 282
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 551;

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(549)
}
var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(568),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(562),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(565),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(563),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(567),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(569),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(566),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(572),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(571),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 562:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "widget_events_content_top",
    attrs: {
      "max-width": "470 600 775"
    }
  }, [(_vm.showTabs) ? _c('ul', {
    staticClass: "tabs_level_1"
  }, [_c('li', [(_vm.defaultTid == null) ? _c('a', {
    class: {
      'active-trail': _vm.tplactiveTID == null
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeTab()
      }
    }
  }, [_vm._v("All")]) : _c('a', {
    class: {
      'active-trail': _vm.tplactiveTID == null
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeTab(_vm.defaultTid, 0)
      }
    }
  }, [_vm._v("All")])]), _vm._v(" "), _vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        'active-trail':
        tab.tid == _vm.tplactiveTID || tab.tid == _vm.activeParentTid,
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeTab(tab.tid, 0)
        }
      }
    }, [_vm._v(_vm._s(tab.name))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('div', {
    staticClass: "widget_events_content_top_ribbon"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTabs && _vm.tplactiveTID),
      expression: "subTabs && tplactiveTID"
    }]
  }, _vm._l((_vm.subTabs), function(subTab, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        'active-sub-term': subTab.tid == _vm.tplactiveTID
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeTab(subTab.tid, 1, subTab.parent_tid)
        }
      }
    }, [_vm._v(_vm._s(subTab.name))])])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.showTabs) ? _c('div', {
    staticClass: "widget_events_content_top_ribbon"
  }, [_c('div', {
    staticClass: "widget_events_content_top_ribbon_title"
  }, [_c('h2', [_c('strong', [_vm._v(_vm._s(_vm.title))]), _c('small', [_vm._v(_vm._s(_vm.subtitle))])])]), _vm._v(" "), (_vm.showSubTags) ? _c('ul', {
    staticClass: "active-sub-nav"
  }, [_c('li', [_c('a', {
    class: {
      'active-sub-term': _vm.statetid.activeTid == _vm.defaultTid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeTab(_vm.defaultTid, 0)
      }
    }
  }, [_vm._v("All")])]), _vm._v(" "), _vm._l((_vm.tabs), function(subTab, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        'active-sub-term': subTab.tid == _vm.tplactiveTID
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeTab(subTab.tid, 1, subTab.parent_tid)
        }
      }
    }, [_vm._v(_vm._s(subTab.name))])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "widget_events_content_list-container"
  }, [_c('ul', {
    staticClass: "view_select"
  }, [_c('li', [_c('a', {
    class: {
      active_view: this.view == 'day'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeView('day')
      }
    }
  }, [_vm._v("Day")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active_view: this.view == 'week'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeView('week')
      }
    }
  }, [_vm._v("Week")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active_view: this.view == 'month'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeView('month')
      }
    }
  }, [_vm._v("Month")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active_view: this.view == 'list'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeView('list')
      }
    }
  }, [_vm._v("List")])])]), _vm._v(" "), _c('div', {
    staticClass: "widget_events_content_list-views"
  }, [(_vm.view == 'day') ? _c('calendar-day') : _vm._e(), _vm._v(" "), (_vm.view == 'week') ? _c('calendar-week') : _vm._e(), _vm._v(" "), (_vm.view == 'month') ? _c('calendar-month') : _vm._e(), _vm._v(" "), (_vm.view == 'list') ? _c('calendar-list') : _vm._e(), _vm._v(" "), _vm._m(0)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "widget_events_content_loader"
    }
  }, [_c('h3', [_vm._v("loading")])])
}]}

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendar_list_view_container"
    }
  }, [_c('div', {
    staticClass: "sidebar_filters"
  }, [_c('section', {
    staticClass: "search_text_container"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.searchText),
      expression: "filters.searchText"
    }],
    attrs: {
      "id": "search_text",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filters.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filters.searchText = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('h3', [_vm._v("By month "), _c('a', {
    staticClass: "clear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearByMonth()
      }
    }
  }, [_vm._v("Clear")])]), _vm._v(" "), _c('div', {
    staticClass: "goup_filters"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    attrs: {
      "for": "search_year"
    }
  }, [_vm._v("Year")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.searchYear),
      expression: "filters.searchYear"
    }],
    attrs: {
      "name": "search_year",
      "id": "search_year"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filters.searchYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.resetFromToDateSearch()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("select")]), _vm._v(" "), _vm._l((_vm.getYearRange), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.searchYear != ""),
      expression: "filters.searchYear != \"\" "
    }],
    staticClass: "form-item"
  }, [_c('label', {
    attrs: {
      "for": "search_year"
    }
  }, [_vm._v("Month")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.searchMonth),
      expression: "filters.searchMonth"
    }],
    attrs: {
      "name": "search_month",
      "id": "search_month"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filters.searchMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("select")]), _vm._v(" "), _vm._l((12), function(n) {
    return _c('option', {
      domProps: {
        "value": n - 1
      }
    }, [_vm._v("  " + _vm._s(_vm.displayMonth(n - 1)) + " ")])
  })], 2)])])]), _vm._v(" "), _c('section', [_c('h3', [_vm._v("By date "), _c('a', {
    staticClass: "clear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearByDate()
      }
    }
  }, [_vm._v("Clear")])]), _vm._v(" "), _c('div', {
    staticClass: "goup_filters"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    attrs: {
      "for": "search_day_start"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "value": _vm.filters.searchDateStart
    },
    on: {
      "change": function($event) {
        _vm.resetYearSearch()
      }
    },
    model: {
      value: (_vm.filters.searchDateStart),
      callback: function($$v) {
        _vm.filters.searchDateStart = $$v
      },
      expression: "filters.searchDateStart"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    attrs: {
      "for": "search_day_end"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "value": _vm.filters.searchDateEnd
    },
    model: {
      value: (_vm.filters.searchDateEnd),
      callback: function($$v) {
        _vm.filters.searchDateEnd = $$v
      },
      expression: "filters.searchDateEnd"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollable"
  }, [(_vm.listEvents.length > 0) ? _c('ul', {
    staticClass: "calendar_list"
  }, _vm._l((_vm.listEvents), function(event) {
    return _c('li', {
      class: _vm.classList(event.dateStart)
    }, [_c('a', {
      staticClass: "bg",
      attrs: {
        "href": event.event_url
      }
    }, [_c('div', {
      staticClass: "top"
    }, [_c('h3', [_vm._v(_vm._s(event.longtitle))]), _vm._v(" "), _c('h4', [(_vm.isToday(event.dateStart)) ? _c('span', [_vm._v("Today")]) : _vm._e(), _vm._v(" "), (event.dateStart == event.dateEnd) ? [_vm._v(" \n\t\t\t\t\t\t\t" + _vm._s(_vm.displayDate(event.start)) + " | " + _vm._s(event.datetime) + "\n\t\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (event.dateStart != event.dateEnd && event.datetime == '(All day)') ? [_vm._v(" \n\t\t\t\t\t\t\t" + _vm._s(_vm.displayDate(event.start)) + " to " + _vm._s(_vm.displayDate(event.end)) + " | " + _vm._s(event.datetime) + "\n\t\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (event.dateStart != event.dateEnd && event.datetime != '(All day)') ? [_vm._v(" \n\t\t\t\t\t\t\t" + _vm._s(_vm.displayDate(event.start, true)) + " to " + _vm._s(_vm.displayDate(event.end, true)) + "\n\t\t\t\t\t\t")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('p', [_vm._v(_vm._s(event.description))])])])])
  })) : _c('div', {
    staticClass: "no_results"
  }, [_vm._v("\n\t\tSorry, No results were found, try again with different filters\n\t")])])])
},staticRenderFns: []}

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "bg",
    class: _vm.getColorClass(_vm.event.tid, _vm.event.parents_id),
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.event.longtitle))]), _vm._v(" "), (_vm.showTime) ? _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.event.datetime))]) : _vm._e()]), _vm._v(" "), (_vm.isClicked) ? _c('EventHover', {
    attrs: {
      "event": _vm.event
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget_events_content_day-container"
  }, [_c('div', {
    staticClass: "list_day-wrapper",
    attrs: {
      "id": _vm.wrapperId
    }
  }, [_c('div', {
    staticClass: "list_day"
  }, _vm._l((_vm.listEvents), function(events, key) {
    return _c('div', {
      staticClass: "day_item",
      attrs: {
        "id": _vm.dayID(key)
      }
    }, [_c('div', {
      staticClass: "dayTitle"
    }, [(_vm.isToday(key)) ? _c('span', [_vm._v("Today")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.dayTitle(key)))]), _vm._v(" "), _c('ul', {
      class: _vm.classEventList(events)
    }, _vm._l((events), function(event) {
      return _c('li', [(event.imagelisting) ? _c('div', {
        staticClass: "event_box_image",
        class: _vm.getColorClass(event.tid, event.parents_id)
      }, [_c('div', {
        staticClass: "explore_thumb_stories"
      }, [_c('div', {
        staticClass: "front"
      }, [_c('div', {
        staticClass: "top"
      }, [_c('img', {
        attrs: {
          "src": event.imagelisting
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "bottom"
      }, [(_vm.classEventList(events) == 'contain_1_items') ? _c('h3', [_vm._v(_vm._s(event.longtitle))]) : _c('h3', [_vm._v(_vm._s(_vm._f("truncate")(event.longtitle, 50)))])])]), _vm._v(" "), _c('div', {
        staticClass: "hover"
      }, [_c('div', {
        staticClass: "close"
      }), _vm._v(" "), _c('div', {
        staticClass: "top"
      }, [_c('h3', {
        staticClass: "fit-text-3"
      }, [_vm._v(_vm._s(event.longtitle))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(event.description) + " ")])]), _vm._v(" "), _c('a', {
        staticClass: "bottom",
        attrs: {
          "href": event.event_url
        }
      }, [_c('span', [_vm._v("Read More")])])])])]) : _c('div', {
        staticClass: "event_box"
      }, [_c('div', {
        staticClass: "inside"
      }, [_c('a', {
        staticClass: "bg",
        class: _vm.getColorClass(event.parents_id),
        attrs: {
          "href": event.event_url
        }
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(event.longtitle))]), _vm._v(" "), _c('div', {
        staticClass: "time"
      }, [_vm._v(_vm._s(event.datetime))])])])])])
    }))])
  }))]), _vm._v(" "), _c('ScrollBar')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info_box",
    class: _vm.getColorClass(_vm.event.tid, _vm.event.parents_id)
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._v(_vm._s(_vm.event.longtitle))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "see_more"
  }, [_vm._v(_vm._s(_vm.event.description) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.eventDate))]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.event.datetime))]), _vm._v(" "), _c('a', {
    staticClass: "see_more",
    attrs: {
      "href": _vm.event.event_url
    }
  }, [_vm._v("See more")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "calendar_view_top"
  }, [_c('div', {
    staticClass: "month_pager"
  }, [_c('button', {
    staticClass: "prev_month",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevMonth()
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('h2', [_c('strong', [_vm._v(_vm._s(_vm.displayMonth))]), _vm._v(" " + _vm._s(_vm.displayYear) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "next_month",
    on: {
      "click": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "prenvet")) { return null; }
        _vm.nextMonth()
      }
    }
  }, [_vm._v(">")])])]), _vm._v(" "), _c('div', {
    staticClass: "calendar_month_view_container"
  }, [_c('div', {
    staticClass: "month_container"
  }, _vm._l((_vm.allMonth), function(days, row) {
    return _c('div', {
      key: row,
      staticClass: "month_row"
    }, [_vm._l((days), function(day, index) {
      return _c('day-cell', {
        key: index,
        attrs: {
          "day": day,
          "row": row
        }
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "multi_event_list"
    }, [_c('ul', _vm._l((_vm.multidaysEvents(days)), function(event, index) {
      return _c('li', {
        key: index,
        style: (_vm.calculateWidth(days, event.dateStart, event.dateEnd))
      }, [_c('OneEvent', {
        attrs: {
          "event": event,
          "showTime": false
        }
      })], 1)
    }))])], 2)
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('calendar')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "days_column",
    class: {
      selected: this.selectclass
    }
  }, [_c('div', {
    staticClass: "top",
    class: {
      'today': _vm.isToday(_vm.day)
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.displayDay(_vm.day, _vm.row)) + " "), _c('span', [_vm._v(_vm._s(_vm.displayDayNum(_vm.day, _vm.row)))])]), _vm._v(" "), (_vm.displayDayEvents(_vm.day).length > 5) ? _c('div', {
    staticClass: "cell_see_more",
    on: {
      "click": _vm.toggleSeeMore
    }
  }, [(_vm.seeMoreToggle) ? _c('span', [_vm._v("See less")]) : _c('span', [_vm._v("See more")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "event_list",
    class: {
      seeMore: _vm.displayDayEvents(_vm.day).length > 5, expand: _vm.seeMoreToggle == true
    }
  }, _vm._l((_vm.displayDayEvents(_vm.day)), function(event) {
    return _c('li', [_c('OneEvent', {
      attrs: {
        "event": event,
        "showTime": false
      },
      on: {
        "eventchild": _vm.childenClicked
      }
    })], 1)
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "calendar_view_top"
  }, [_c('h2', [_c('strong', [_vm._v(_vm._s(_vm.displayMonth))]), _vm._v(" " + _vm._s(_vm.displayYear))]), _vm._v(" "), _c('div', {
    staticClass: "week_pager"
  }, [_c('button', {
    staticClass: "prev_week",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevWeek()
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.displayWeek))]), _vm._v(" "), _c('button', {
    staticClass: "next_week",
    on: {
      "click": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "prenvet")) { return null; }
        _vm.nextWeek()
      }
    }
  }, [_vm._v(">")])])]), _vm._v(" "), _c('div', {
    staticClass: "calendar_week_view_container"
  }, [_c('div', {
    staticClass: "week_overflow",
    attrs: {
      "id": _vm.wrapperId
    }
  }, [_c('div', {
    staticClass: "week_container"
  }, [_vm._l((_vm.allWeek), function(day) {
    return _c('div', {
      staticClass: "day_column"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('strong', [_vm._v(_vm._s(_vm.displayDayName(day)))]), _vm._v(" "), _c('small', {
      class: {
        'today': _vm.isToday(day)
      }
    }, [_vm._v(_vm._s(_vm.displayDayNum(day)))])]), _vm._v(" "), _c('ul', {
      staticClass: "event_list"
    }, _vm._l((_vm.displayDayEvents(day)), function(event) {
      return _c('li', [_c('div', {
        staticClass: "event_box"
      }, [_c('div', {
        staticClass: "inside"
      }, [_c('OneEvent', {
        attrs: {
          "event": event,
          "showTime": true,
          "longTitle": false
        }
      })], 1)])])
    }))])
  }), _vm._v(" "), _c('div', {
    staticClass: "multi_event_list"
  }, [_c('ul', _vm._l((_vm.multidaysEvents), function(event) {
    return _c('li', {
      style: (_vm.calculateWidth(event.dateStart, event.dateEnd, event.daysNum))
    }, [_c('OneEvent', {
      attrs: {
        "event": event,
        "showTime": false,
        "longTitle": true
      }
    })], 1)
  }))])], 2)]), _vm._v(" "), _c('ScrollBarHorizontal')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scrollbar-wrapper-horizontal"
  }, [_c('div', {
    staticClass: "scrollbar",
    attrs: {
      "id": _vm.barId
    },
    on: {
      "click": _vm.calculatePosition
    }
  }, [_c('div', {
    staticClass: "scrollbar-slider",
    attrs: {
      "id": _vm.sliderId
    },
    on: {
      "mousedown": _vm.bindMouseDown
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scrollbar-wrapper"
  }, [_c('a', {
    attrs: {
      "id": "go_to_today"
    },
    on: {
      "click": function($event) {
        _vm.goToToday()
      }
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('div', {
    staticClass: "scrollbar",
    attrs: {
      "id": _vm.barId
    },
    on: {
      "click": _vm.calculatePosition
    }
  }, [_c('div', {
    staticClass: "scrollbar-slider",
    attrs: {
      "id": _vm.sliderId
    },
    on: {
      "mousedown": _vm.bindMouseDown
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(286);
module.exports = __webpack_require__(285);


/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(120);


var scrollBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({});

/* harmony default export */ __webpack_exports__["a"] = (scrollBus);

/***/ })

},[578]);


// WEBPACK FOOTER //
// sites/js/app.js